import * as classnames from 'classnames'
import get from 'lodash-es/get'
import * as React from 'react'
import { Link } from 'react-router-dom'

import { Site } from '../../../../common/constants/siteList'
import {
  isSearchPageLocation,
  isSimilarItemsPageLocation
} from '../../../../common/utils/locationHelper'
import { getFlattenLocation } from '../../../../common/utils/urlHelper'
import ChevronLeftIcon from '../../../shared/components/icons/chevronLeft'
import LoadingSpinner from '../../../shared/components/icons/loadingSpinner'
import SearchPageContentWrapper from '../../../shared/components/searchPageContentWrapper'
import FeatureContainer from '../../../shared/containers/feature'
import SearchPageArticle from '../../../v0/pages/search/content/searchPageArticle'
import SearchPageRelatedPosts from '../../../v0/pages/search/content/searchPageRelatedPosts'
import V0SearchResults from '../../../v0/pages/search/result/searchResultBody'
import SearchResults from './result/searchResults'
import SearchContentSection from './searchContentSection'
import SearchHeader from './searchHeader'

import GraphicRiverEaseOfUseSurvey from '../../../shared/components/surveyBanners/graphicRiverEaseOfUseSurvey'

import * as containerStyles from './containers.module.css'
import * as styles from './index.module.css'

import { Props } from '../../../shared/containers/searchPageContainer'

interface IState {
  searchLocation: any | null
}

class SearchPage extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props)
    this.state = {
      searchLocation: null
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const {
      locationParams,
      onSearchPageDidUpdate,
      previousLocation
    } = this.props

    if (
      previousLocation &&
      isSearchPageLocation(previousLocation.pathname) &&
      !isSimilarItemsPageLocation(previousLocation) &&
      this.state.searchLocation !== previousLocation
    ) {
      this.setState({ searchLocation: previousLocation })
    }

    onSearchPageDidUpdate(
      locationParams,
      prevProps.userHasLoadAttempt,
      prevProps.results
    )
  }

  public render() {
    const {
      userHasLoadAttempt,
      searchResultsViewType,
      previousLocation,
      location,
      results,
      loading,
      searchHeadings,
      ingestedContent,
      currentSite,
      baseUrl,
      relatedSearches,
      itemDetailsOpen,
      push,
      experiments,
      experimentsReady,
      openModal,
      locationParams,
      makeSearchLink
    } = this.props

    const { searchLocation } = this.state
    const flattenLocation = getFlattenLocation(location)
    const didYouMeanByTerms = get(results, 'suggestions') as any
    const authorSuggestion = get(results, 'matching_author')
    const showSimilarImagesPage = !!flattenLocation.query.item_id

    this.toggleMobilePageScroll(itemDetailsOpen)

    if (showSimilarImagesPage) {
      const showBackToSearchLink = !!searchLocation
      const itemName = get(results, 'item.name')
      const showItemName = !!itemName
      const loadingContainer = (
        <div className={styles.loadingContainer}>
          <LoadingSpinner />
        </div>
      )

      const resultsContainer = (
        <div>
          <FeatureContainer name="!transition-to-new-design">
            <SearchResults
              baseUrl={baseUrl}
              results={results}
              location={location}
              currentSite={currentSite}
              locationParams={locationParams}
              makeSearchLink={makeSearchLink}
            />
          </FeatureContainer>
          <FeatureContainer name="transition-to-new-design">
            <V0SearchResults matches={results.matches} location={location} />
          </FeatureContainer>
        </div>
      )

      return (
        <SearchPageContentWrapper experimentsReady={experimentsReady}>
          <div className={styles.pageContainer}>
            <div className={containerStyles.searchContentSection}>
              <div className={styles.similarItemsHeader}>
                <p>
                  {results.total_hits} similar items
                  {showItemName && [' to ', <strong>{itemName}</strong>]}
                </p>
                {showBackToSearchLink && (
                  <p>
                    <Link className={styles.goBackLink} to={searchLocation}>
                      <ChevronLeftIcon width="8" height="10" />
                      <span className={styles.goBackLinkLabel}>
                        Return to search results
                      </span>
                    </Link>
                  </p>
                )}
              </div>
              {loading ? loadingContainer : resultsContainer}
            </div>
          </div>
        </SearchPageContentWrapper>
      )
    } else {
      const totalHits = results.total_hits

      return (
        <SearchPageContentWrapper experimentsReady={experimentsReady}>
          <div className={styles.pageContainer}>
            <SearchHeader
              location={flattenLocation}
              totalHits={totalHits}
              didYouMeanByTerms={didYouMeanByTerms}
              authorSuggestion={authorSuggestion}
              currentSite={currentSite}
              searchHeadings={searchHeadings}
              openModal={openModal}
              locationParams={locationParams}
              makeSearchLink={makeSearchLink}
            />
            <div className={styles.surveyContainer}>
              <GraphicRiverEaseOfUseSurvey currentSite={currentSite} />
            </div>
            <SearchContentSection
              searchResultsViewType={searchResultsViewType}
              baseUrl={baseUrl}
              results={results}
              location={location}
              loading={loading}
              currentSite={currentSite}
              relatedSearches={relatedSearches}
              push={push}
              experiments={experiments}
              locationParams={locationParams}
              makeSearchLink={makeSearchLink}
            />
            {ingestedContent && (
              <div className={containerStyles.searchContentSection}>
                {!!ingestedContent.article && (
                  <SearchPageArticle
                    html={ingestedContent.article}
                    centre
                    wide
                  />
                )}
                {ingestedContent.related_posts &&
                  ingestedContent.related_posts.length === 3 && (
                    <SearchPageRelatedPosts
                      posts={ingestedContent.related_posts}
                      centre
                    />
                  )}
              </div>
            )}
          </div>
        </SearchPageContentWrapper>
      )
    }
  }

  private toggleMobilePageScroll(itemDetailsOpen: boolean) {
    if (typeof window === 'undefined') {
      return
    }

    if (itemDetailsOpen) {
      document.body.classList.add(styles.noMobileScroll)
    } else {
      document.body.classList.remove(styles.noMobileScroll)
    }
  }
}

export default SearchPage
